import { FormSection, TextField } from "@/components/tambour-sur-mesure/FormControls";

export const CommonFields = ({ form, input }) => (
  <FormSection numero="02" titre="Votre structure" texte="Pour savoir à qui adresser la proposition." testid="intervention-section-structure">
    <div className="grid md:grid-cols-2 gap-5">
      <TextField required label="Nom de la structure" testid="intervention-structure" {...input("structure")} placeholder="Association, entreprise, centre, famille…" />
      <TextField required label="Nom du responsable" testid="intervention-responsable" {...input("responsable")} />
    </div>
    <TextField required label="Adresse du lieu de l’intervention" testid="intervention-adresse" {...input("adresse")} placeholder="Rue, numéro, NPA, localité" />
    <div className="grid md:grid-cols-2 gap-5">
      <TextField required type="email" label="E-mail" testid="intervention-email" {...input("email")} />
      <TextField required type="tel" label="Téléphone" testid="intervention-telephone" {...input("telephone")} />
    </div>
  </FormSection>
);